module.exports = __webpack_public_path__ + "assets/img/7afa19d55d1498da1926cfb8bb33fa3c.png";